import { render } from "./DomainSettings.vue?vue&type=template&id=68fd17aa"
import script from "./DomainSettings.vue?vue&type=script&lang=js"
export * from "./DomainSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__